import styled from 'styled-components'

const Styles = styled.div`
  p{
    font-size:14px;
    font-weight:400;
    line-height:16px;
    text-align:left;
  }
  .item-list{
    display:flex;
    flex-direction:column;
    .item{
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      margin:5px 0px 0px 0px;
      .dot{
        height: 6px;
        width: 6px;
        background-color:#7161FF;
        border-radius: 50%;
        display: inline-block;
        z-index:100;
        margin-right: 10px;
        margin-top:4px;
      }
      p{
        color:white;
        margin:0;
        font-size:13px;
        font-weight:400;
        z-index:100;
        line-height:16px;
        display:flex;
        flex:1;
      }
    }
    .item-size{
      margin-top: 0px;
      padding-left: 16px;
    }
  }
`

export default Styles